/* istanbul ignore file */
import { ActivityType } from 'domain/shared/timeline';
import { ButtonsSelectInput, ButtonsSelectInputProps } from 'framework/form';

const ActivityTypeInput = (props: ButtonsSelectInputProps) => {
  return (
    <ButtonsSelectInput
      {...props}
      options={Object.entries(ActivityType).map(entry => {
        const [value, label] = entry;

        return {
          label,
          value,
        };
      })}
    />
  );
};

export default ActivityTypeInput;
